import { useTranslation } from "react-i18next";
import { Faq } from "@/components/site/Faq";
import { StandalonePageShell } from "@/components/site/StandalonePageShell";
import { useSiteContent } from "@/lib/useSiteContent";

export default function FaqPage() {
  const { t } = useTranslation();
  const home = useSiteContent("home");
  const contact = useSiteContent("contact");
  const dealers = useSiteContent("dealers");

  return (
    <StandalonePageShell
      content={{ home, contact, dealers }}
      eyebrow={t("pages.faq.eyebrow")}
      title={t("pages.faq.title")}
      description={t("pages.faq.description")}
    >
      <div data-testid="faq-page"><Faq /></div>
    </StandalonePageShell>
  );
}
